import { useTranslation } from "react-i18next";
import { View } from "react-native";
import { Label } from "./label";
import { Text } from "./text";
import { ToggleGroup, ToggleGroupItem } from "./toggle-group";

/** Monday–Friday. Weekends are not selectable. Daily repeat uses this whole set. */
export const ISO_SCHOOL_WEEKDAYS = [1, 2, 3, 4, 5] as const;

interface DaySelectRowProps {
    daysOfWeek: number[];
    toggleWeekday: (days: string[]) => void;
    testIDPrefix: string;
}

export function DaySelectRow({
    daysOfWeek,
    toggleWeekday,
    testIDPrefix,
}: DaySelectRowProps) {
    const { t } = useTranslation();
    return (
        <View className="flex flex-row flex-wrap items-center justify-between gap-2 w-full">
            <Label>{t("ui.daysOfWeek")}</Label>
            <ToggleGroup
                type="multiple"
                variant="outline"
                value={daysOfWeek.map((day) => day.toString())}
                onValueChange={(value) =>
                    toggleWeekday(value?.map((day) => day.toString()) ?? [])
                }
            >
                {ISO_SCHOOL_WEEKDAYS.map((day, index) => {
                    return (
                        <ToggleGroupItem
                            key={day}
                            value={day.toString()}
                            testID={`${testIDPrefix}-${day}`}
                            isFirst={index === 0}
                            isLast={index === ISO_SCHOOL_WEEKDAYS.length - 1}
                        >
                            <Text>{t(`ui.weekdayShort.${day}`)}</Text>
                        </ToggleGroupItem>
                    );
                })}
            </ToggleGroup>
        </View>
    );
}
